import { 
	CROP_IMAGE_LOADING,
	CROP_IMAGE_LOADED,
	CROP_IMAGE_START_UPLOADING,
	CROP_IMAGE_UPLOADED,
	CROP_IMAGE_LOAD_CANCELLED,
	CROP_IMAGE_ADD_NEW_CROP,
	CROP_IMAGE_RESET_CROPS,
	CROP_CLEAR_CROPS,
	CROP_IMAGE_CROPPING_CANCELLED
} from 'constants/actiontypes';

const INITIAL_STATE = {
	loading: false,
	loaded: false,
	uploading: false,
	uploaded: false,
	result: {},
	image: {},
	crops: {}
};

export default (state=INITIAL_STATE, action) => {
	switch(action.type) {
		case CROP_IMAGE_LOADING:
			return Object.assign({}, state, {loading: true, loaded: false});
		case CROP_IMAGE_LOAD_CANCELLED:
			return Object.assign({}, state, {loading: false, loaded: false});
		case CROP_IMAGE_LOADED:
			return Object.assign({}, state, {loading: false, loaded: true, image: action.image});
		case CROP_IMAGE_ADD_NEW_CROP:
			return Object.assign({}, state, {crops: Object.assign({}, state.crops, {
				[action.name]: {
					width: action.width,
					height: action.height,
					x: action.x,
					y: action.y,
					originalWidth: action.originalWidth,
					originalHeight: action.originalHeight,
					data: action.data || ''
				}
			})});
		case CROP_IMAGE_CROPPING_CANCELLED:
			return Object.assign({}, state, {
				uploading: false,
				uploaded: false,
				result: {}
			});
		case CROP_IMAGE_START_UPLOADING:
			return Object.assign({}, state, {uploading: true});
		case CROP_CLEAR_CROPS:
			return Object.assign({}, state, {crops: {}});
		case CROP_IMAGE_UPLOADED:
			return Object.assign({}, state, {
				uploaded: true,
				uploading: false,
				result: action.data
			});
		case CROP_IMAGE_RESET_CROPS:
			return INITIAL_STATE;
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./reducers/cropper.js
 **/